<template>
  <div id="FactFamilyPlan" class="section">
    <!-- TOTAL INSURANCE INFO. -->
    <div class="column is-12">
      <p class="title is-4 has-text-left">รายละเอียดทุนปกป้องครอบครัว</p>
      <div class="columns has-text-left is-multiline">
        <!-- 1 : HOUSE -->
        <div class="column is-12">
          <b-field label="บ้าน / คอนโด"> </b-field>
          <div class="columns is-multiline is-align-end">
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="มูลค่าทรัพย์สิน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="มูลค่าทรัพย์สิน"
                  v-model="house_value"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ยอดผ่อนคงเหลือ">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ยอดผ่อนคงเหลือ"
                  v-model="house_installmemnt"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ทุนประกัน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ทุนประกัน"
                  v-model="house_insurance"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ส่วนต่าง">
                <b-input
                  type="number"
                  min="0"
                  disabled
                  custom-class="prompt-font"
                  placeholder="ส่วนต่าง"
                  v-model="house_diff"
                />
              </b-field>
            </div>
          </div>
        </div>
        <!-- 2 : CAR -->
        <div class="column is-12">
          <b-field label="รถยนต์"> </b-field>
          <div class="columns is-multiline is-align-end">
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="มูลค่าทรัพย์สิน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="มูลค่าทรัพย์สิน"
                  v-model="car_value"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ยอดผ่อนคงเหลือ">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ยอดผ่อนคงเหลือ"
                  v-model="car_installmemnt"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ทุนประกัน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ทุนประกัน"
                  v-model="car_insurance"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ส่วนต่าง">
                <b-input
                  disabled
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ส่วนต่าง"
                  v-model="car_diff"
                />
              </b-field>
            </div>
          </div>
        </div>
        <!-- 3 : EDUCATION -->
        <div class="column is-12">
          <b-field label="การศึกษาลูก"> </b-field>
          <div class="columns is-multiline is-align-end">
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ค่าการศึกษา">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ค่าการศึกษา"
                  v-model="education_value"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ยอดคงเหลือ">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ยอดผ่อนคงเหลือ"
                  v-model="education_installmemnt"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ทุนประกัน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ทุนประกัน"
                  v-model="education_insurance"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ส่วนต่าง">
                <b-input
                  disabled
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ส่วนต่าง"
                  v-model="education_diff"
                />
              </b-field>
            </div>
          </div>
        </div>
        <!-- 4 : BUSINESS / SKILL -->
        <div class="column is-12">
          <b-field label="ธุรกิจ / ความสามารถ"> </b-field>
          <div class="columns is-multiline is-align-end">
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ค่าความสามารถ">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ค่าความสามารถ"
                  v-model="capability_value"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ยอดคงเหลือ">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ยอดผ่อนคงเหลือ"
                  v-model="capability_installmemnt"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ทุนประกัน">
                <b-input
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ทุนประกัน"
                  v-model="capability_insurance"
                />
              </b-field>
            </div>
            <div class="column is-3-desktop is-6-tablet is-12-mobile">
              <b-field label="ส่วนต่าง">
                <b-input
                  disabled
                  type="number"
                  min="0"
                  custom-class="prompt-font"
                  placeholder="ส่วนต่าง"
                  v-model="capability_diff"
                />
              </b-field>
            </div>
          </div>
          <b-checkbox size="is-small" v-model="capability_is_skill">
            ประเภทความสามารถ
          </b-checkbox>
        </div>
      </div>
    </div>
    <div class="btn-mt">
      <div class="columns is-centered">
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            class="prompt-font"
            @click.prevent="backwardStep()"
            >ย้อนกลับ
          </b-button>
        </div>
        <div v-if="edited" class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            outlined
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="updateFactInfoState()"
          >
            บันทึก
          </b-button>
        </div>
        <div class="column is-2-desktop is-4-tablet is-12-mobile">
          <b-button
            expanded
            type="is-primary"
            class="prompt-font"
            @click.prevent="saveFactInfoState()"
          >
            เสร็จสิ้น
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  name: "FactFamilyPlan",
  props: ["edited"],
  computed: {
    ...mapState(["factsheet_protection"]),
    house_diff: function() {
      let result = null;
      if (this.house_installmemnt) {
        result = +this.house_installmemnt;
      }
      if (this.house_insurance) {
        result -= +this.house_insurance;
      }
      return result;
    },
    car_diff: function() {
      let result = null;
      if (this.car_installmemnt) {
        result = +this.car_installmemnt;
      }
      if (this.car_insurance) {
        result -= +this.car_insurance;
      }
      return result;
    },
    education_diff: function() {
      let result = null;
      if (this.education_installmemnt) {
        result = +this.education_installmemnt;
      }
      if (this.education_insurance) {
        result -= +this.education_insurance;
      }
      return result;
    },
    capability_diff: function() {
      let result = null;
      if (this.capability_installmemnt) {
        result = +this.capability_installmemnt;
      }
      if (this.capability_insurance) {
        result -= +this.capability_insurance;
      }
      return result;
    }
  },
  data() {
    return {
      house_value: null,
      house_installmemnt: null,
      house_insurance: null,
      car_value: null,
      car_installmemnt: null,
      car_insurance: null,
      education_value: null,
      education_installmemnt: null,
      education_insurance: null,
      capability_value: null,
      capability_installmemnt: null,
      capability_insurance: null,
      capability_is_skill: false
    };
  },
  methods: {
    ...mapMutations({
      setFactSheetProtection: "SET_FACTSHEET_PROTECTION"
    }),
    /* For Display Existing Information */
    setUpFamilyProtectInfo(family_protect_info) {
      this.house_value = family_protect_info.house.asset_value;
      this.house_installmemnt = family_protect_info.house.installment_left;
      this.house_insurance = family_protect_info.house.insurance_coverage;

      this.car_value = family_protect_info.car.asset_value;
      this.car_installmemnt = family_protect_info.car.installment_left;
      this.car_insurance = family_protect_info.car.insurance_coverage;

      this.education_value = family_protect_info.education.asset_value;
      this.education_installmemnt =
        family_protect_info.education.installment_left;
      this.education_insurance =
        family_protect_info.education.insurance_coverage;

      this.capability_value = family_protect_info.business.asset_value;
      this.capability_installmemnt =
        family_protect_info.business.installment_left;
      this.capability_insurance =
        family_protect_info.business.insurance_coverage;
      this.capability_is_skill = family_protect_info.business.business_flag;
    },
    /* Button Action Handler */
    saveFactInfoState: function() {
      if (!this.edited) {
        let plan_family = this.createFactInfoFamilyObject();
        this.setFactSheetProtection(plan_family);
      }
      this.$emit("form_completed");
    },
    updateFactInfoState: function() {
      if (this.edited) {
        let plan_family = this.createFactInfoFamilyObject();
        this.setFactSheetProtection(plan_family);
        this.$emit("existing_sheet_updated");
      }
    },
    backwardStep: function() {
      this.$emit("back");
    },
    /* PARAMS*/
    createFactInfoFamilyObject: function() {
      const plan_family = {
        house: {
          asset_value: +this.house_value,
          installment_left: +this.house_installmemnt,
          insurance_coverage: +this.house_insurance
        },
        car: {
          asset_value: +this.car_value,
          installment_left: +this.car_installmemnt,
          insurance_coverage: +this.car_insurance
        },
        education: {
          asset_value: +this.education_value,
          installment_left: +this.education_installmemnt,
          insurance_coverage: +this.education_insurance
        },
        business: {
          asset_value: +this.capability_value,
          installment_left: +this.capability_installmemnt,
          insurance_coverage: +this.capability_insurance,
          business_flag: !this.capability_is_skill
        }
      };
      return plan_family;
    }
  },
  beforeMount() {
    if (this.edited) {
      this.setUpFamilyProtectInfo(this.factsheet_protection);
    }
  }
};
</script>
